var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalls(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_626_211)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_626_211",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 512,
    height: 512
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 0H0V512H512V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_626_211)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_626_211",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 512,
    height: 512
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512 256C512 114.615 397.385 0 256 0C114.615 0 0 114.615 0 256C0 397.385 114.615 512 256 512C397.385 512 512 397.385 512 256Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_626_211)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512 256C512 114.615 397.385 0 256 0C114.615 0 0 114.615 0 256C0 397.385 114.615 512 256 512C397.385 512 512 397.385 512 256Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.704 -0.213193C203.489 2.27254 172.854 10.7354 142.621 25.5019C68.6982 61.6079 16.4254 131.834 2.39648 213.885C-4.75712 255.723 -0.496735 302.783 14.1008 343.167C45.6171 430.362 121.908 493.971 213.818 509.686C239.661 514.105 272.349 514.105 298.193 509.686C353.003 500.315 401.291 474.924 440.169 435.036C454.057 420.787 460.588 412.694 470.989 396.847C527.004 311.497 527.004 200.649 470.989 115.299C431.621 55.3164 369.346 14.6223 298.348 2.48726C278.386 -0.925278 256.919 -1.84989 235.704 -0.213193ZM199.957 118.39C205.796 121.575 207.739 127.13 211.653 151.823C212.641 158.052 214.89 169.051 216.652 176.264C220.427 191.728 220.725 199.708 217.741 205.449C216.579 207.684 209.185 215.916 201.308 223.74C193.433 231.564 186.989 238.388 186.989 238.905C186.989 240.887 203.193 261.28 212.525 271.041C233.37 292.846 259.199 310.453 285.202 320.584L290.847 322.784L301.087 305.076C317.412 276.847 316.88 277.211 339.114 279.159C347.33 279.879 359.347 280.167 365.818 279.8C389.038 278.481 395.934 282.132 400.146 297.971C403.314 309.887 408.53 345.307 407.95 350.959C406.472 365.321 393.595 378.351 377.262 382.012C359.714 385.944 324.98 385.47 303.6 381.005C280.446 376.169 250.181 363.746 227.905 349.933C186.416 324.206 148.275 280.342 128.651 235.789C121.337 219.184 116.528 190.139 116.409 161.859C116.331 143.134 116.398 142.547 119.305 136.662C123.735 127.689 128.185 122.963 135.79 119.152L142.621 115.729L169.461 116.062C192.951 116.353 196.757 116.643 199.957 118.39Z",
    fill: "#7366FF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_626_211"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalls);
export default __webpack_public_path__ + "static/media/calls.86467e16bddd7dee3b956d7bbfa4190c.svg";
export { ForwardRef as ReactComponent };